import React from "react";
import { Note } from "../Note";
import { SubjectTitle } from "../SubjectTitle";

export const SubjectDetail = ({
  sub_code,
  full_marks,
  pass_marks,
  internal_marks,
  title,
}) => {
  return (
    <div className="subject-details">
      <SubjectTitle title={title} />
      <h2 className="fw-600 my-2">Subject Details:</h2>
      <p className="fw-400 my-2">
        <span className="text-black-accent">Subject Code: </span>
        <span className="text-sans">{sub_code}</span>
      </p>
      <p className="fw-400 my-2">
        <span className="text-black-accent">Affiliated to: </span>
        Tribhuvan University (TU)
      </p>
      <p className="my-2 mark">
        {full_marks && (
          <span className="text-black-accent">
            Full Marks:{" "}
            <span className="text-black text-sans">{full_marks}</span>
          </span>
        )}
        {pass_marks && (
          <span className="fw-400 text-black-accent">
            Pass Marks:{" "}
            <span className="text-black text-sans">{pass_marks}</span>
          </span>
        )}
        {internal_marks && (
          <span className="fw-400 text-black-accent">
            Internal Marks:
            <span className="text-black text-sans"> {internal_marks}</span>
          </span>
        )}
      </p>
      <Note
        topic="Note"
        text="Visit the link below and
        prepare well with lot of resources."
      />
    </div>
  );
};
